export default __webpack_public_path__ + "static/media/shirt7.e22b867b.jpeg";